export default function HR() {
	return <span className='w-full h-0.25 bg-black-90' />;
}
